export default __webpack_public_path__ + "static/media/carreAgneau.630e5e6c.jpg";